import { assoc, compose, head, pick } from 'ramda'

export const cleanRequest = (item, entity) =>
  compose(
    pick(['id', 'name', 'enabled', 'entity', 'type', 'description', 'documentId', 'checklistId', 'placeType']),
    assoc('documentId', item.document?.id || null),
    assoc('checklistId', item.checklist?.id || null),
    assoc('entity', entity)
  )(item)
